(function(){
  if(window.__plumeReferenceInitialized)return;
  window.__plumeReferenceInitialized=true;
  function initialize(){
    document.querySelectorAll('[data-comparison]').forEach(function(root){
      if(root.dataset.ready)return;root.dataset.ready='true';
      var controls=root.querySelector('[data-comparison-controls]');
      var status=root.querySelector('#comparison-status'),use=root.querySelector('#comparison-use');
      if(!controls||!status||!use)return;
      controls.hidden=false;
      function update(){
        var visible=0;root.querySelectorAll('[data-comparison-row]').forEach(function(row){
          row.hidden=!((status.value==='all'||row.dataset.analogue===status.value)&&(use.value==='all'||row.dataset.use===use.value));if(!row.hidden)visible++;
        });
        root.querySelector('[data-comparison-count]').textContent=visible+' of 13 products';
        if(window.plumeAeoTrack)window.plumeAeoTrack('aeo_comparison_use',{ingredient_filter:status.value,use_filter:use.value});
      }
      status.addEventListener('change',update);use.addEventListener('change',update);
      root.querySelector('[data-comparison-reset]').addEventListener('click',function(){status.value='all';use.value='all';update();});
      function revealAnchor(){var row=document.getElementById(location.hash.slice(1));if(row&&root.contains(row)&&row.matches('[data-comparison-row]')){status.value='all';use.value='all';root.querySelectorAll('[data-comparison-row]').forEach(function(r){r.hidden=false});root.querySelector('[data-comparison-count]').textContent='13 of 13 products';row.scrollIntoView();}}
      window.addEventListener('hashchange',revealAnchor);revealAnchor();
    });
    document.querySelectorAll('[data-reference-print]').forEach(function(button){button.hidden=false;button.addEventListener('click',function(){window.print()});});
  }
  var openBeforePrint=[];
  window.addEventListener('beforeprint',function(){document.querySelectorAll('.plume-reference details').forEach(function(d){openBeforePrint.push([d,d.open]);d.open=true;});});
  window.addEventListener('afterprint',function(){openBeforePrint.forEach(function(pair){pair[0].open=pair[1]});openBeforePrint=[];});
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initialize);else initialize();
})();
